/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BasePurchaseSummary } from './BasePurchaseSummary';
import { CoursePrice } from './CoursePrice';
const CoursePurchaseSummaryParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('course')],
    ['purchasedItem', CoursePrice, 'purchased_item'],
]), BasePurchaseSummary);
export class CoursePurchaseSummary extends BasePurchaseSummary {
    static decode(input) {
        return CoursePurchaseSummaryParser.decode(input).map(res => new CoursePurchaseSummary(res));
    }
    static unsafeDecode(input) {
        return CoursePurchaseSummary.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CoursePurchaseSummaryParser.encode(data);
    }
    static schema() {
        return CoursePurchaseSummaryParser.schema();
    }
}
